export const SET_MULTI_DB_FILTERS = 'SET_MULTI_DB_FILTERS';
export const setMDQSFilters = (filterData: any) => ({
  type: SET_MULTI_DB_FILTERS,
  payload: filterData,
});

const initialState: any = {};

interface Action {
  type: string;
  payload: any;
}

const mdqsFilterReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_MULTI_DB_FILTERS:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
export default mdqsFilterReducer;
